import UmCollection from './main'

UmCollection.install = function(Vue) {
  Vue.component(UmCollection.name, UmCollection)
}

export default UmCollection
